import React from 'react';
import { Link as LinkRouter } from "gatsby";
import './all-posts-button.styles.scss';

const AllPostsButton = () => {
    return (
        <div>
            <LinkRouter to='/' className='all-posts-button'>
                Ver todas as publicações
            </LinkRouter>
        </div>
    )
}

export default AllPostsButton;
